<template>
  <!-- View access control modal -->
  <b-modal id="modal-tabs"
           ref="view-processing-type"
           hide-footer
           @hide="closeViewProcessingTypeModal"
  >
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('dashboard.activities.modal.title') }}
      </h4>
      <h5>{{ $t('analytics.activities.processing_type_title') }}</h5>
    </div>

    <b-tabs class="mt-3">
      <b-tab :title="$t('system.approved')" active @click="approvedTabClicked">
        <div class="modal-tabs-scrollable">
          <div v-for="object in systemsApproved" :key="object.id">
            <h5>
              <router-link
                  :to="{ name: 'activities.view', params: { slug: object.slug }}"
                  qid="s-view-page-link"
              >
                {{ object.name }}
              </router-link>
            </h5>
            <span v-if="object.users && object.users.length" class="mr-2" >
              {{ $t('system.owners_label') }}:
            </span>
            <span class="mr-1"
                  v-for="user in object.users"
                  qid="p-owners-list"
            >
              <Avatar :object="user" size="xs"></Avatar>
            </span>
            <span v-if="object.tags_translated && object.tags_translated.length" class="mr-2 ml-2">
              {{ $t('system.tags_label') }}:
            </span>
            <span class="mr-1"
                  v-for="tag in object.tags_translated"
                  qid="p-tags-list"
            >
              <span class="badge badge-info mb-1">
                {{ tag.name_translated }}
              </span>
            </span>
            <hr>
          </div>
          <div class="text-center" @click="loadSystemProcessingType(1)" v-if="showMore && !loading">
            <a>{{ $t('system.show_more') }}</a>
          </div>
          <div class="text-center" v-if="systemsApproved && !systemsApproved.length && !loading">
            <a>{{ $t('system.no_results') }}</a>
          </div>
          <div class="text-center" v-if="loading">
              <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2"/>
              {{ $t('system.loading') }}
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('system.rejected')" @click="rejectedTabClicked">
        <div class="modal-tabs-scrollable">
          <div v-for="object in systemsRejected" :key="object.id">
            <h5>
              <router-link
                  :to="{ name: 'activities.view', params: { slug: object.slug }}"
                  qid="s-view-page-link"
              >
                {{ object.name }}
              </router-link>
            </h5>
            <span v-if="object.users && object.users.length" class="mr-2">
              {{ $t('system.owners_label') }}:
            </span>
            <span class="mr-1"
                  v-for="user in object.users"
                  qid="p-owners-list"
            >
              <Avatar :object="user" size="xs"></Avatar>
            </span>
            <span v-if="object.tags_translated && object.tags_translated.length" class="mr-2 ml-2">
              {{ $t('system.tags_label') }}:
            </span>
            <span class="mr-1"
                  v-for="tag in object.tags_translated"
                  qid="p-tags-list"
            >
              <span class="badge badge-info mb-1">
                {{ tag.name_translated }}
              </span>
            </span>
            <hr>
          </div>
          <div class="text-center" @click="loadSystemProcessingType(0)" v-if="showMore && !loading">
            <a>{{ $t('system.show_more') }}</a>
          </div>
          <div class="text-center" v-if="systemsRejected && !systemsRejected.length && !loading">
            <a>{{ $t('system.no_results') }}</a>
          </div>
          <div class="text-center" v-if="loading">
              <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2"/>
              {{ $t('system.loading') }}
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('system.unvalidated')" @click="naTabClicked">
        <div class="modal-tabs-scrollable">
          <div v-for="object in systemsNA" :key="object.id">
            <h5>
              <router-link
                  :to="{ name: 'activities.view', params: { slug: object.slug }}"
                  qid="s-view-page-link"
              >
                {{ object.name }}
              </router-link>
            </h5>
            <span v-if="object.users && object.users.length" class="mr-2">
              {{ $t('system.owners_label') }}:
            </span>
            <span class="mr-1"
                  v-for="user in object.users"
                  qid="p-owners-list"
            >
              <Avatar :object="user" size="xs"></Avatar>
            </span>
            <span v-if="object.tags_translated && object.tags_translated.length" class="mr-2 ml-2">
              {{ $t('system.tags_label') }}:
            </span>
            <span class="mr-1"
                  v-for="tag in object.tags_translated"
                  qid="p-tags-list"
            >
              <span class="badge badge-info mb-1">
                {{ tag.name_translated }}
              </span>
            </span>
            <hr>
          </div>
          <div class="text-center" @click="loadSystemProcessingType()" v-if="showMore && !loading">
            <a>{{ $t('system.show_more') }}</a>
          </div>
          <div class="text-center" v-if="systemsNA && !systemsNA.length && !loading">
            <a>{{ $t('system.no_results') }}</a>
          </div>
          <div class="text-center" v-if="loading">
              <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2"/>
              {{ $t('system.loading') }}
          </div>
        </div>
      </b-tab>
      <b-button class="mt-4 mb-4 float-right"
                variant="success"
                @click="closeViewProcessingTypeModal"
                qid="create-p-cancel-button"
      >
        {{ $t('processes.policies.view.close') }}
      </b-button>
    </b-tabs>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'ProcessingTypeValidationsModal',
    data: function() {
      return {
        error: '',
        systemsApproved: [],
        systemsRejected: [],
        systemsNA: [],
        page: 1,
        showMore: true,
        loading: true
      }
    },
    props: {
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.openViewProcessingTypeModal()
        }
      }
    },
    methods: {
      approvedTabClicked() {
        this.systemsApproved = []
        this.page = 1;
        this.showMore = true;
        this.loading = true;
        this.loadSystemProcessingType(1)
      },
      rejectedTabClicked() {
        this.systemsRejected = []
        this.page = 1;
        this.showMore = true;
        this.loading = true;
        this.loadSystemProcessingType(0)
      },
      naTabClicked() {
        this.systemsNA = []
        this.page = 1;
        this.showMore = true;
        this.loading = true;
        this.loadSystemProcessingType()
      },
      openViewProcessingTypeModal() {
        this.page = 1;
        this.loadSystemProcessingType(1)
        this.$refs['view-processing-type'].show()
      },
      closeViewProcessingTypeModal() {
        this.showMore = true;
        this.systemsApproved = []
        this.systemsRejected = []
        this.systemsNA = []
        this.$emit('closeViewModal');
        this.$refs['view-processing-type'].hide()
      },
      loadSystemProcessingType(type) {
        let self = this;
        piincHttp.get('activities', { params:
          {
            client: this.getClient.slug,
            page: this.page,
            processing_type_validation: type == 1 || type == 0 ? type : 'null'
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 10 || (response.data.items.length == 10 && response.data.total_count == 10 * self.page))) {
            self.showMore = false;
          }

          self.page += 1;
          self.loading = false;

          if (type == 1) {
            self.systemsApproved.push(...response.data.items)
          } else if (type == 0) {
            self.systemsRejected.push(...response.data.items)
          } else {
            self.systemsNA.push(...response.data.items)
          }
        }, function() {});
      },
    },
    components: {
      Avatar
    },
    created () {

    }
  }
</script>
